import React, { useEffect, useState } from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import HomeView from '../VIEWS/HomeView';
import Program1 from '../VIEWS/program1';
import Program2 from '../VIEWS/program2';
import Program3 from '../VIEWS/program3';
import Program4 from '../VIEWS/program4';
import Program5 from '../VIEWS/program5';
import Program6 from '../VIEWS/program6';
import Program7 from '../VIEWS/program7';
import Program8 from '../VIEWS/program8';
import Program9 from '../VIEWS/program9';
import Program10 from '../VIEWS/program10';
import Program11 from '../VIEWS/program11';
import Program12 from '../VIEWS/program12';
import Program13 from '../VIEWS/program13';
import Program15 from '../VIEWS/program15';
import Program14 from '../VIEWS/program14';
import Program16 from '../VIEWS/program16';
import Program17 from '../VIEWS/program17';
import Program18 from '../VIEWS/program18';
import Program19 from '../VIEWS/program19';
import Program20 from '../VIEWS/program20';
import Program21 from '../VIEWS/program21';
import Program22 from '../VIEWS/program22';
import Program23 from '../VIEWS/program23';
import Program24 from '../VIEWS/program24';
import Program25 from '../VIEWS/program25';
import Program26 from '../VIEWS/program26';
import Program27 from '../VIEWS/program27';
import ProgramNo from '../VIEWS/programNo';
import EvesProgram from '../VIEWS/evesProgram';

const RoutingController: React.FunctionComponent = props => {

    useEffect(() => { }, [])

    return(
        <HashRouter>
        <Routes>
            <Route path = "/home" element = { <HomeView /> }></Route>
            <Route path = "/program1" element = { <Program1 /> }></Route>
            <Route path = "/program2" element = { <Program2 /> }></Route>
            <Route path = "/program3" element = { <ProgramNo /> }></Route>
            <Route path = "/program4" element = { <ProgramNo /> }></Route>
            <Route path = "/program5" element = { <Program5/> }></Route>
            <Route path = "/program6" element = { <Program6 /> }></Route>
            <Route path = "/program7" element = { <ProgramNo /> }></Route>
            <Route path = "/program8" element = { <Program8 /> }></Route>
            <Route path = "/program9" element = { <Program9 /> }></Route>
            <Route path = "/program10" element = { <Program10 /> }></Route>
            <Route path = "/program11" element = { <Program11 /> }></Route>
            <Route path = "/program12" element = { <Program12 /> }></Route>
            <Route path = "/program13" element = { <Program13 /> }></Route>
            <Route path = "/program14" element = { <Program14 /> }></Route>
            <Route path = "/program15" element = { <Program15 /> }></Route>
            <Route path = "/program16" element = { <ProgramNo /> }></Route>
            <Route path = "/program17" element = { <ProgramNo /> }></Route>
            <Route path = "/program18" element = { <ProgramNo /> }></Route>
            <Route path = "/program19" element = { <ProgramNo /> }></Route>
            <Route path = "/program20" element = { <ProgramNo/> }></Route>
            <Route path = "/program21" element = { <ProgramNo /> }></Route>
            <Route path = "/program22" element = { <ProgramNo /> }></Route>
            <Route path = "/program23" element = { <ProgramNo /> }></Route>
            <Route path = "/program24" element = { <ProgramNo /> }></Route>
            <Route path = "/program25" element = { <ProgramNo /> }></Route>
            <Route path = "/program26" element = { <ProgramNo /> }></Route>
            <Route path = "/program27" element = { <ProgramNo /> }></Route>
            <Route path = "/evesprogram" element = { <EvesProgram /> }></Route>
            <Route path = "/" element = { <HomeView  /> }></Route>

        </Routes>

    </HashRouter>
           
    )

}

export default RoutingController